export default __webpack_public_path__ + "static/media/nyc-large.377eda5e.gif";